// import * as FeatureFlagService from '../service/FeatureFlag.service';

window.truenth = {};

/**
 * Utils: collection of reusable functions
 */
window.truenth.utils = (() => {
  /**
   *
   * @returns {string}
   */
  function getLanguage() {
    return window.location.pathname.split('/')[1];
  }

  /**
   * Get base URL including hostname and language code
   */
  function getBaseUrl() {
    const { protocol, host } = window.location;
    return `${protocol}//${host}/${getLanguage()}/`;
  }

  /**
   * Get URL parameters from the URL passed
   */
  function getUrlParameters() {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      vars[key] = value;
    });
    return vars;
  }

  /**
   * Validates email format
   * @param {string} email The email to be validated
   */
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  /**
   * Check if the user has given us the consent or not
   * @returns {boolean}
   */
  function hasConsented() {
    if (
      window.truenth.cookies.getCookie('cookieConsent') !== undefined ||
      // Check for cookie in localStorage when loading MLM from OA
      localStorage.getItem('cookiesAcceptedAt') !== undefined
    ) {
      return true;
    }

    return false;
  }

  /**
   * Generate a unique number
   * @returns {*|string}
   */
  function generateUniqueNumber() {
    let d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now(); // use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 | 0; // eslint-disable-line no-bitwise
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16); // eslint-disable-line no-bitwise
    });
  }

  /**
   * Calculate the time passed given the pageLoadTime
   * @param pageLoadTime
   * @returns {number}
   */
  function getTimeSincePageLoad(pageLoadTime) {
    const now = +new Date();

    return parseInt((now - pageLoadTime) / 1000); // eslint-disable-line radix
  }

  return {
    getBaseUrl,
    getUrlParameters,
    validateEmail,
    hasConsented,
    getLanguage,
    generateUniqueNumber,
    getTimeSincePageLoad
    // getFeatureFlags: FeatureFlagService.getFeatureFlags
  };
})();
